<template>
  <router-view />
</template>
<script setup>
</script>
<style>
* {
  box-sizing: border-box;
}
</style>
